export default __webpack_public_path__ + "static/fraud-prevention-7894a441cc23d325d7313b0fe3f7b7ef.png";